import bg2 from "../images/backgrounds/bg-2.png";
/* jshint esversion: 6 */
/* jshint ignore:start */

import React, { useContext, useEffect, useRef, useState } from "react";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import ProgressBar from "./ProgressBar";
import "react-phone-number-input/style.css";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import { showTost } from "../showTost";
import { getOtpDeviceId } from "../utils/otpDeviceId";

const emptyOtp = () => Array(6).fill('');
const isOtpEnabled = (value) => ["yes", "1", "true"].includes(String(value || "").toLowerCase());

const PhoneNum = () => {

  const { setNumber, setCcode, basUrl } = useContext(MyContext);

  const [value, setValue] = useState();
  const [otpShow, setOtpShow] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [otpSessionId, setOtpSessionId] = useState("");
  const [inputValues, setInputValues] = useState(emptyOtp());
  const [smsType, setSmsType] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [phonePayload, setPhonePayload] = useState({ mobile: "", ccode: "" });

  const InputRef = useRef(Array.from({ length: 6 }, () => null));

  const navigate = useNavigate();

  const startOtpTimer = () => {
    setTimeLeft(30);
  };

  const resetOtpState = () => {
    setOtpSessionId("");
    setInputValues(emptyOtp());
    setTimeLeft(0);
    setIsSendingOtp(false);
    setIsVerifyingOtp(false);
  };

  const sendOtp = async (provider, mobile, ccode) => {
    if (!provider || !mobile) {
      showTost({ title: "Unable to send OTP. Please try again." });
      return;
    }

    setIsSendingOtp(true);
    setOtpSessionId("");
    setInputValues(emptyOtp());
    try {
      const endpoint = provider === "Twilio" ? "twilio_otp" : "msg_otp";
      const res = await axios.post(`${basUrl}${endpoint}`, { mobile, ccode, device_id: getOtpDeviceId() });
      if (res.data.Result !== "true") {
        throw new Error(res.data.ResponseMsg || "Unable to send OTP");
      }
      if (!res.data.otp_session_id) {
        throw new Error("OTP session missing. Please try again.");
      }
      setOtpSessionId(res.data.otp_session_id);
      
      const autoOtp = String(
        res.data.otp ||
        res.data.otp_code ||
        res.data.otp_autofill ||
        res.data.code ||
        res.data.Otp ||
        res.data.OTP ||
        res.data.user_otp ||
        res.data.otp_value ||
        ""
      ).replace(/\D/g, "");

      if (autoOtp && autoOtp.length > 0) {
        const digits = autoOtp.slice(0, 6).split("");
        const nextValues = emptyOtp();
        digits.forEach((digit, i) => { nextValues[i] = digit; });
        setInputValues(nextValues);
        setTimeout(() => {
          InputRef.current[Math.min(digits.length, 6) - 1]?.focus();
        }, 100);
      } else {
        setInputValues(emptyOtp());
      }

      startOtpTimer();
      showTost({ title: res.data.ResponseMsg || "OTP sent successfully" });
    } catch (error) {
      setOtpSessionId("");
      setInputValues(emptyOtp());
      setTimeLeft(0);
      showTost({ title: error?.message || "Unable to send OTP. Please try again." });
    } finally {
      setIsSendingOtp(false);
    }
  };

  const SubmitHandler = async () => {
    if (value) {

      const formattedPhoneNumber = formatPhoneNumberIntl(value);
      const countryCallingCode = formattedPhoneNumber.split(' ')[0];
      const mobileNumber = formattedPhoneNumber.split(" ").splice(1);

      const result = mobileNumber.join("");
      const Ccode = countryCallingCode;
      setCcode(Ccode);
      setNumber(result);
      setPhonePayload({ mobile: result, ccode: Ccode });

      try {
        const mobileRes = await axios.post(`${basUrl}mobile_check`, {
          mobile: result,
          ccode: Ccode,
        });
        if (mobileRes.data.Result !== "true") {
          showTost({ title: mobileRes.data.ResponseMsg });
          return;
        }

        const smsRes = await axios.post(`${basUrl}sms_type`);
        if (smsRes.data.Result !== "true") {
          showTost({ title: smsRes.data.ResponseMsg || "Unable to load OTP settings." });
          return;
        }

        if (isOtpEnabled(smsRes.data.otp_auth)) {
          const provider = smsRes.data.SMS_TYPE === "Twilio" ? "Twilio" : "Msg91";
          setSmsType(provider);
          setOtpShow(true);
          sendOtp(provider, result, Ccode);
        } else {
          navigate("/birthdate");
        }
      } catch (error) {
        showTost({ title: "Unable to verify mobile number. Please try again." });
      }

    } else {
      showTost({ title: "Please Enter MobileNumber" });
    }
  };

  const HandlelChamge = (index, value) => {
    const digits = String(value || "").replace(/\D/g, "");
    if (digits.length > 1) {
      const nextValues = emptyOtp();
      digits.slice(0, 6).split("").forEach((digit, digitIndex) => {
        nextValues[digitIndex] = digit;
      });
      setInputValues(nextValues);
      const nextIndex = Math.min(digits.length, 6) - 1;
      InputRef.current[nextIndex]?.focus();
      return;
    }

    const updatedValues = [...inputValues];
    updatedValues[index] = digits;
    setInputValues(updatedValues);
    if (digits && index < InputRef.current.length - 1) {
      InputRef.current[index + 1].focus();
    }
  };

  const InputHandle = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !e.target.value) {
      InputRef.current[index - 1].focus();
    }
  };

  useEffect(() => {
    if (timeLeft <= 0) return;

    const Timer = setTimeout(() => {
      setTimeLeft(prevTimeLeft => {
        return prevTimeLeft <= 1 ? 0 : prevTimeLeft - 1;
      });
    }, 1000);
    return () => clearTimeout(Timer);

  }, [timeLeft]);


  const ResendOtpHandler = () => {
    if (timeLeft > 0 || isSendingOtp) return;
    sendOtp(smsType, phonePayload.mobile, phonePayload.ccode);
  };


  const CheckOtpHandler = async () => {
    if (isVerifyingOtp) return;

    const enteredOtp = inputValues.join("");
    if (!/^\d{6}$/.test(enteredOtp)) {
      showTost({ title: "Please enter valid OTP" });
      return;
    }

    if (!otpSessionId) {
      showTost({ title: "OTP expired. Please request a new OTP." });
      return;
    }

    setIsVerifyingOtp(true);
    try {
      const res = await axios.post(`${basUrl}verify_otp`, {
        otp_session_id: otpSessionId,
        otp: enteredOtp,
        mobile: phonePayload.mobile,
        ccode: phonePayload.ccode,
        device_id: getOtpDeviceId(),
      });

      if (res.data.Result === "true") {
        showTost({ title: res.data.ResponseMsg || "OTP verified successfully." });
        navigate("/birthdate");
      } else {
        showTost({ title: res.data.ResponseMsg || "Please enter valid OTP" });
        setIsVerifyingOtp(false);
      }
    } catch (error) {
      showTost({ title: "Unable to verify OTP. Please try again." });
      setIsVerifyingOtp(false);
    }
  };

  return (
    <div>
      <div className="w-[100%] multisteup-wrapper pt-[20px] max-_430_:pt-[0px] Test" style={{ backgroundImage: `url(${bg2})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover" }}>
        <div className="container mx-auto">
          {otpShow
            ? <section className="steps step-1 active rounded-[24px] relative">
              <ProgressBar step={2} />
              <div className="text-center mt-[10px]">
                <h1 className="text-[22px] max-_430_:text-[26px] font-[600] max-_430_:w-[300px]">
                  Enter Your OTP
                </h1>
              </div>
              <div className="mt-[20px] w-[100%]">
                <div className="flex items-center justify-center gap-[10px]">
                  {inputValues.map((value, index) => (
                    <input
                      key={index}
                      ref={(e) => (InputRef.current[index] = e)}
                      onChange={(e) => HandlelChamge(index, e.target.value)}
                      onKeyDown={(e) => InputHandle(index, e)}
                      value={value}
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className="form-control font-[600] input-otpnumber outline-[rgba(152,14,255,255)]"
                      name="otp1"
                      id={`otp${index + 1}`}
                      maxLength="1"
                    />
                  ))}
                </div>
              </div>
              <button
                disabled={timeLeft > 0 || isSendingOtp}
                onClick={ResendOtpHandler}
                className="mt-[40px] font-[600] text-[16px]"
                style={{ color: timeLeft > 0 || isSendingOtp ? "#970eff60" : "rgba(152,14,255,255)" }}
              >
                {isSendingOtp ? "Sending..." : timeLeft > 0 ? `Resend OTP (${timeLeft})` : "Resend OTP"}
              </button>
              <button
                onClick={CheckOtpHandler}
                disabled={isVerifyingOtp}
                className="btn btn-w-md nextstep mt-[24px]"
              >
                <div className="flex items-center justify-center gap-[10px]">
                  <span className="font-bold text-[1.25rem] text-white">
                    {isVerifyingOtp ? "Please wait" : "Submit"}
                  </span>
                </div>
              </button>
              <h3
                onClick={() => {
                  resetOtpState();
                  setOtpShow(false);
                }}
                className="mt-[20px] cursor-pointer"
              >
                Back
              </h3>
            </section>
            : <section className="steps step-1 active rounded-[24px] relative ">
              <ProgressBar step={2} />
              <div className="text-start mt-[10px]">
                <h1 className="text-[22px] max-_430_:text-[26px] font-[600] max-_430_:w-[300px]">
                  Your GoMeet identity &#128526;
                </h1>
                <p className="text-[14px] mt-[10px] max-_430_:text-[17px] max-_380_:text-[16px]">
                  Add your phone number and your job to tell other what you
                  do for a living.
                </p>
              </div>
              <div className="mt-[20px] w-[100%]">
                <div className="border-[2px] border-gray-300 focus-within:border-[rgba(152,14,255,255)] rounded-[12px] px-[15px] py-[10px] bg-white flex items-center w-full min-h-[50px]">
                  <PhoneInput
                    className="text-black w-[100%] font-[500] outline-none"
                    international
                    defaultCountry={"IN"}
                    value={value}
                    onChange={setValue}
                    name="phone"
                    placeholder="Enter phone number"
                  />
                </div>
              </div>
              <button
                onClick={SubmitHandler}
                className="btn btn-w-md nextstep mt-[24px]"
              >
                <div className="flex items-center justify-center gap-[10px]">
                  <span className="font-bold text-[1.25rem] text-white">
                    Next
                  </span>
                  <svg
                    className="mx-6"
                    width="19"
                    height="13"
                    viewBox="0 0 19 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.75455 5.73075H15.4523L11.3296 1.60802C11.2552 1.53617 11.1959 1.45022 11.155 1.35519C11.1142 1.26016 11.0927 1.15795 11.0918 1.05453C11.0909 0.951108 11.1106 0.848543 11.1498 0.752818C11.189 0.657094 11.2468 0.570128 11.3199 0.496995C11.3931 0.423862 11.48 0.366026 11.5758 0.326862C11.6715 0.287698 11.7741 0.267991 11.8775 0.268889C11.9809 0.269788 12.0831 0.291275 12.1781 0.332096C12.2732 0.372918 12.3591 0.432257 12.431 0.50665L17.8833 5.95896C18.0293 6.10503 18.1113 6.30311 18.1113 6.50965C18.1113 6.71618 18.0293 6.91427 17.8833 7.06033L12.431 12.5126C12.2841 12.6545 12.0873 12.733 11.8831 12.7313C11.6789 12.7295 11.4835 12.6476 11.3391 12.5032C11.1947 12.3587 11.1128 12.1634 11.111 11.9592C11.1092 11.7549 11.1877 11.5582 11.3296 11.4113L15.4523 7.28855H1.75455C1.54797 7.28855 1.34986 7.20649 1.20378 7.06041C1.05771 6.91434 0.975649 6.71623 0.975649 6.50965C0.975649 6.30307 1.05771 6.10495 1.20378 5.95888C1.34986 5.81281 1.54797 5.73075 1.75455 5.73075Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </button>
            </section>}
        </div>
      </div>
    </div>
  );
};

export default PhoneNum;
/* jshint ignore:end */
